


























































import '../../styles/view-tile.css'
import '../../styles/alert-tile.css'
import Vue, { PropOptions } from 'vue'
import Format from '../../util/Format'
import IAlert from '@/viewModel/IAlert'
import { Alerts } from '@/dataLayer/Alerts'
import moment from 'moment'
import { CIcon } from '@coreui/icons-vue'
import { cilArrowRight } from '@coreui/icons-pro'

export default Vue.extend({
  data() {
    return {
      imageUrl: '/img/wide-placeholder-image.png',
      arrowIcon: cilArrowRight,
      formatDateFn: (strDate: string) => Format.formatDate(strDate),
    }
  },
  components: {
    CIcon,
  },
  props: {
    alert: {
      type: Object,
      required: true,
    } as PropOptions<IAlert>,
    alertTags: {
      type: Array,
      required: true,
    } as PropOptions<{ id: number; name: string }[]>,
    showRead: {
      type: Boolean,
      required: false,
      default: true,
    } as PropOptions<boolean>,
    showView: {
      type: Boolean,
      required: false,
      default: true,
    } as PropOptions<boolean>,
  },
  mounted: async function () {
    if (this.alert.imageUrl) {
      try {
        const canLoadImage = await fetch(this.alert.imageUrl)

        if (canLoadImage.ok) this.imageUrl = this.alert.imageUrl
      } catch {
        // continue with default
      }
    }
  },
  filters: {
    formatDate(date) {
      return moment(date).format('yyyy-MM-DD')
    },
  },
  computed: {
    showEndDate: function () {
      return (
        this.alertDate &&
        moment(this.alert.endDate).format('yyyy-MM-DD') !==
          moment(this.alert.startDate).format('yyyy-MM-DD')
      )
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    getFromUrl() {
      return this.$route.path
    },
    async markRead(id: number) {
      await Alerts.markRead(id)
      this.$emit('alert-read', id)
      window.location.reload();
    },
  },
  name: 'AlertThumbnail',
})
